<template>
  <nav>
    <div class="projects" @click="goToHome">
      <div><span class="ficon"></span> Alle Projekte</div>
    </div>
    <div v-if="selectedExhibition !== null" class="projects-dropdown">
      <div class="selected">
        <div>
          {{ exhibitions.find(x => x.id === selectedExhibition).name  }}
<!--          <div class="ficon" v-if="!dropdown"></div>-->
<!--          <div class="ficon" v-if="dropdown"></div>-->
        </div>
      </div>
<!--      <div class="others" v-if="dropdown">-->
<!--   <div v-for="exhibition in exhibitions" :key="exhibition.id" @click="goTo(exhibition.id)">-->
<!--          {{ exhibition.name }}-->
<!--          {{ exhibition.id }}-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div v-if="selectedExhibition !== null" class="menu">
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TSidebar',
  data() {
    return {
      dropdown: false,
    };
  },
  computed: {
    exhibitions() {
      return this.$store.state.exhibitions;
    },
    selectedExhibition() {
      return this.$store.state.selectedExhibition;
    },
  },
  methods: {
    goToHome() {
      if (this.$route.name !== 'Overview') {
        this.$store.state.selectedRoom = null;
        this.$store.state.selectedExhibition = null;
        document.getElementById('loading').classList.remove('hide');
        setTimeout(() => {
          this.$router.push('/');
          document.getElementById('loading').classList.add('hide');
        }, 500);
      }
    },
    goTo(id) {
      this.$store.state.selectedExhibition = id;
      const exhibition = this.exhibitions.find((e) => e.id === id);
      this.$store.state.focusAStart = exhibition.start;
      this.$store.state.focusAEnd = exhibition.end;
      // this.$loading(true);
      // document.getElementById('loading').classList.remove('hide');
      setTimeout(() => {
        this.$router.push(`/project/${id}`);
      }, 400);
    },
  },
};
</script>

<style scoped lang='scss'>
  @import "../assets/scss/theme";

  nav {
    flex-grow: 1;
    width: 18rem;
    min-width: 18rem;
    max-width: 18rem;
    background: $dark100;

    @media (max-width: 1199.98px) {
      height: 4rem;
      width: 100%;
      min-width: initial;
      max-width: initial;
      flex-grow: unset;
    }

    .projects {
      background: $creme100;
      height: 4rem;
      display: flex;
      padding: 0 2rem;
      align-items: center;
      font-size: 1.125rem;
      font-weight: $font-weight-semi-bold;
      cursor: pointer;

      >div {
        text-decoration: none;
        color: $black100;
      }

      &:hover {
        background: $orange100;

        >div {
          color: $white;
        }
      }

      .ficon {
        margin-right: 1rem;
        margin-top: -.25rem;
      }
    }

    .projects-dropdown {

      .selected {
        height: 4rem;
        display: flex;
        align-items: center;
        padding: 0 2rem;
        font-size: 1.25rem;
        border-bottom: 2px solid transparentize($creme100, .75);

        >div {
          text-decoration: none;
          color: $creme100;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        &:hover {
          /*<!--background: $creme75;-->*/

          >div {
            color: $creme75;
          }
        }
      }

      .others {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 1.25rem;
        cursor: pointer;
        background: $white;

        >div {
          color: $black100;
          padding: 0 2rem;
          width: 100%;
          height: 4rem;
          display: flex;
          align-items: center;

          &:hover {
            background: $orange100;
            color: $white;
          }
        }
      }

      @media (max-width: 1199.98px) {
        display: none;
      }


      .ficon {
        margin-right: 1rem;
        margin-top: -.25rem;
      }
    }

    .menu {
      /*padding-top: 2rem;*/
      display: flex;
      flex-direction: column;

      @media (max-width: 1199.98px) {
        display: none;
      }

      a {
        text-decoration: none;
        color: $creme100;
        height: 4rem;
        padding: 0 2rem;
        font-size: 1.125rem;
        display: flex;
        align-items: center;
        border-left: 2px solid transparent;
        margin-bottom: .5rem;

        .ficon {
          margin-right: 1rem;
          margin-top: -.25rem;
        }

        &:hover {
          background: transparentize($creme100, .95);
        }

        &.router-link-exact-active {
          background: transparentize($creme100, .75);
          border-left: 2px solid $creme100;
        }
      }
    }
  }
</style>
